import { PortfolioRegionType } from "../types";

export const getRegionTypeSuffix = (
  regionType: PortfolioRegionType | undefined,
  availableTypes: string[]
): string => {
  if (availableTypes.length <= 1 || !regionType) return "";
  return regionType === "hk" ? "_hksar" : "_global";
};
